import { render } from "./RecordsDashboard.vue?vue&type=template&id=973b5d3a&scoped=true"
import script from "./RecordsDashboard.vue?vue&type=script&lang=js"
export * from "./RecordsDashboard.vue?vue&type=script&lang=js"

import "./RecordsDashboard.vue?vue&type=style&index=0&id=973b5d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973b5d3a"]])

export default __exports__